export default "__VITE_ASSET__ClDX0e8q__"